import Spin from 'antd/lib/spin';
import CommonContainer from './CommonContainer';

const CommonSpinner = () => {
  return (
    <CommonContainer>
      <Spin></Spin>
    </CommonContainer>
  );
};
export default CommonSpinner;
